import React, { useState, useEffect, useCallback, useRef } from 'react';

import { CheckboxList } from '../../../../../../UiKit';
import { toString } from 'lodash-es';

const SubItemSelectionView = (props) => {
  const {
    heading = 'Free Customisation Items',
    parentItemId,
    subItems = [],
    selectSubItems = () => {},
    pickup = false,
    quantity = 0,
    selectedSubItems = [],
    mainItemSelected = false,
  } = props;

  const [itemList, setItemList] = useState([]);
  const [itemIdDetailsMap, setItemIdDetailsMap] = useState({});

  useEffect(() => {
    if (selectedSubItems && selectedSubItems.length) {
      const selectedItems = [];
      for (let i = 0; i < selectedSubItems.length; i++) {
        let item = selectedSubItems[i];
        item = {
          ...item,
          pickup: pickup,
          quantity: quantity,
        };
        selectedItems.push(item);
      }
      selectSubItems(selectedItems, parentItemId);
    }
  }, [pickup, quantity]);

  const getSelelctedItemDetailsMap = useCallback(() => {
    const selectedItemDetails = {};
    if (selectedSubItems && selectedSubItems.length) {
      for (let i = 0; i < selectedSubItems.length; i++) {
        let item = selectedSubItems[i];
        item = {
          ...item,
          selected: true,
        };
        selectedItemDetails[item?.item_id] = item;
      }
    }
    return selectedItemDetails;
  }, [selectedSubItems]);

  const prevMainItemSelectedRef = useRef(mainItemSelected);

  useEffect(() => {
    var itemDetails = [];
    var itemIdDetails = {};
    var selelctedItemDetailsMap = getSelelctedItemDetailsMap();
    for (let i = 0; i < subItems.length; i++) {
      const subItem = subItems[i];

      const isSelected = mainItemSelected
        ? true
        : selelctedItemDetailsMap?.[subItem.id]?.selected;

      const itemForCheckbox = {
        type: subItem?.id ? toString(subItem?.id) : null,
        text: subItem?.text,
        selected: isSelected,
        disabled: mainItemSelected,
      };

      const itemDetailsForEvaluation = {
        item_id: subItem?.id,
        parent_item_id: parentItemId,
        custom_unit: subItem?.custom_unit,
        custom_value: 0,
        quantity: quantity ? quantity : subItem?.quantity,
        pickup: pickup,
      };

      itemDetails.push(itemForCheckbox);
      itemIdDetails[subItem?.id] = itemDetailsForEvaluation;
    }

    setItemList(itemDetails);
    setItemIdDetailsMap(itemIdDetails);
  }, [
    subItems,
    pickup,
    quantity,
    mainItemSelected,
    selectedSubItems,
    getSelelctedItemDetailsMap,
  ]);

  useEffect(() => {
    if (mainItemSelected) {
      const itemIdDetails = {};
      for (let i = 0; i < subItems.length; i++) {
        const subItem = subItems[i];
        itemIdDetails[subItem?.id] = {
          item_id: subItem?.id,
          parent_item_id: parentItemId,
          custom_unit: subItem?.custom_unit,
          custom_value: 0,
          quantity: quantity ? quantity : subItem?.quantity,
          pickup: pickup,
        };
      }
      const allItems = subItems.map((item) => itemIdDetails[item.id]);
      selectSubItems(allItems, parentItemId);
    } else if (prevMainItemSelectedRef.current) {
      selectSubItems([], parentItemId);
    }
    prevMainItemSelectedRef.current = mainItemSelected;
  }, [mainItemSelected, subItems, selectSubItems, pickup, quantity, parentItemId]);

  const selectSubItem = (selectedItemIds) => {
    // Prevent changing selections if main item is selected
    if (mainItemSelected) return;

    if (!selectedItemIds || !selectedItemIds.length) {
      selectSubItems([], parentItemId);
      return;
    }

    const selectedItems = [];
    for (let i = 0; i < selectedItemIds.length; i++) {
      const item = itemIdDetailsMap[selectedItemIds[i]];
      selectedItems.push(item);
    }
    selectSubItems(selectedItems, parentItemId);
  };

  return (
    <div className='tw-flex tw-flex-col tw-w-full'>
      <div className='tw-flex tw-flex-col tw-font-medium tw-text-300 tw-text-green-700 tw-mt-2'>
        {heading}
      </div>
      <div className='tw-flex tw-flex-col'>
        <CheckboxList
          key={itemList
            .filter((item) => item.selected)
            .map((item) => item.type)
            .join(',')}
          items={itemList}
          selectOptions={mainItemSelected ? () => {} : selectSubItem}
          disabled={mainItemSelected}
          textStyle={{
            fontWeight: '500',
            fontSize: '1.2rem',
          }}
          alreadyChecked={itemList
            .filter((item) => item.selected)
            .map((item) => item.type)}
        />
      </div>
    </div>
  );
};
export default SubItemSelectionView;
